export class CampaignListRequest{
    public IncludeExpired:boolean = false;
    public IncludeInactive:boolean = false;
    constructor(values: Object = {}){
          Object.assign(this, values);
    }
}